'use es6';

export const FOLDER = 'FOLDER';
export const LAYOUT = 'LAYOUT';
export const TEMPLATE = 'TEMPLATE';
export const CUSTOM_WIDGET = 'CUSTOM_WIDGET';
export const GLOBAL_GROUP = 'GLOBAL_GROUP';
export const GLOBAL_WIDGET = 'GLOBAL_WIDGET';
export const CSS = 'CSS';
export const JS = 'JS';
export const THEME = 'THEME';
export const RAW_ASSET = 'RAW_ASSET';